import React from 'react';

function PackageInfo({ applicationPackageList, handelSetApplicationPackageId, formData }) {
    if (!applicationPackageList?.length) {
        return (
            <div className="flex justify-center items-center py-4 bg-secondary-100 rounded-10">
                <span className="text-gray-500">
                    {formData?.ApplicationId
                        ? 'No pricing found for this application or user current currency!'
                        : 'No application selected'}
                </span>
            </div>
        );
    }

    return (
        <div>
            <h2 className="mb-2">Pricing:</h2>
            <ul>
                {applicationPackageList?.map((item) => (
                    <li key={item?.packageId} className="bg-secondary-100 rounded-10 mb-2">
                        <button
                            type="button"
                            className="flex justify-between items-center w-full p-3"
                            onClick={() => handelSetApplicationPackageId(item)}
                        >
                            <div className="flex items-center">
                                <input
                                    checked={formData?.PackageId === item?.packageId}
                                    type="radio"
                                    name="PackageSelection"
                                    onChange={() => handelSetApplicationPackageId(item)}
                                    className="mr-1 checked:bg-red-700"
                                />
                                <span>{item?.title}</span>
                            </div>
                            <div>
                                <span>{item?.text}</span>
                            </div>
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default PackageInfo;
